(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["griflor-antes-despues"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(frame){
    if(frame.dataset.gfBaListo === '1'){ return; }
    frame.dataset.gfBaListo = '1';
    var handle = frame.querySelector('[data-gf-ba-handle]');
    if(!handle){ return; }

    function poner(pct){
      if(pct < 0){ pct = 0; }
      if(pct > 100){ pct = 100; }
      frame.style.setProperty('--x', pct + '%');
      handle.setAttribute('aria-valuenow', Math.round(pct));
      /* que lado ocupa mas pantalla: eso decide que pastilla se destaca */
      frame.classList.toggle('lado-despues', pct < 50);
      frame.classList.toggle('lado-antes', pct >= 50);
    }
    function leer(){
      var v = parseFloat(frame.style.getPropertyValue('--x'));
      return isNaN(v) ? 50 : v;
    }
    function desdeEvento(e){
      var caja = frame.getBoundingClientRect();
      if(caja.width === 0){ return; }
      poner(((e.clientX - caja.left) / caja.width) * 100);
    }

    poner(leer());

    var arrastrando = false;
    frame.addEventListener('pointerdown', function(e){
      arrastrando = true;
      frame.classList.add('is-drag');
      /* capturo el puntero en el marco: asi sigue funcionando aunque el dedo
         o el mouse se salga de la foto mientras arrastra */
      try { frame.setPointerCapture(e.pointerId); } catch(err){}
      desdeEvento(e);
    });
    frame.addEventListener('pointermove', function(e){
      if(!arrastrando){ return; }
      e.preventDefault();
      desdeEvento(e);
    });
    function soltar(e){
      if(!arrastrando){ return; }
      arrastrando = false;
      frame.classList.remove('is-drag');
      try { frame.releasePointerCapture(e.pointerId); } catch(err){}
    }
    frame.addEventListener('pointerup', soltar);
    frame.addEventListener('pointercancel', soltar);

    handle.addEventListener('keydown', function(e){
      var paso = e.shiftKey ? 10 : 2;
      if(e.key === 'ArrowLeft'){ poner(leer() - paso); e.preventDefault(); }
      else if(e.key === 'ArrowRight'){ poner(leer() + paso); e.preventDefault(); }
      else if(e.key === 'Home'){ poner(0); e.preventDefault(); }
      else if(e.key === 'End'){ poner(100); e.preventDefault(); }
    });
  }
  function boot(){ document.querySelectorAll('[data-gf-ba]').forEach(init); }
  if(document.readyState !== 'loading'){ boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["griflor-bestsellers"] && !Shopify.designMode) return;
  try {
    
(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(s){
    if(s.__gf){return;} s.__gf = true;
    var track = s.querySelector('[data-gf-track]');
    if(track){
      var prev = s.querySelector('[data-gf-prev]'), next = s.querySelector('[data-gf-next]');
      function step(){var c = track.querySelector('.gf-bs__card');return c ? c.getBoundingClientRect().width + 20 : 300;}
      if(prev){prev.addEventListener('click', function(){track.scrollBy({left:-step()*1.25, behavior:'smooth'});});}
      if(next){next.addEventListener('click', function(){track.scrollBy({left:step()*1.25, behavior:'smooth'});});}
      // En celular arranca con la 2da tarjeta al medio: asi asoma una de cada lado.
      // scroll-snap-type:mandatory pelea contra el scrollLeft programatico y lo
      // devolvia a 0, por eso se apaga el snap mientras se posiciona.
      function centrarSegunda(){
        if(!window.matchMedia('(max-width: 749px)').matches){ return; }
        var cards = track.querySelectorAll('.gf-bs__card');
        if(cards.length < 3){ return; }
        if(track.scrollLeft > 4){ return; }   // el usuario ya movio el carrusel
        var snap = track.style.scrollSnapType, beh = track.style.scrollBehavior;
        track.style.scrollSnapType = 'none';
        track.style.scrollBehavior = 'auto';
        var tb = track.getBoundingClientRect(), cb = cards[1].getBoundingClientRect();
        track.scrollLeft += (cb.left + cb.width / 2) - (tb.left + tb.width / 2);
        track.style.scrollBehavior = beh;
        track.style.scrollSnapType = snap;
      }
      requestAnimationFrame(centrarSegunda);
      // de nuevo cuando cargan las fotos: el layout se reacomoda y puede volver a 0
      window.addEventListener('load', centrarSegunda);
    }
    if(reduce){s.classList.add('is-in');return;}
    var io = new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{threshold:.12});
    io.observe(s);
  }
  function boot(){var l = document.querySelectorAll('.gf-bs');for(var i=0;i<l.length;i++){init(l[i]);}}
  if(document.readyState !== 'loading'){boot();}else{document.addEventListener('DOMContentLoaded', boot);}

  /* Agregar sin salir de la pagina: abre el carrito lateral del tema.
     Delegado en document y con guarda, asi no se duplica si hay varias
     instancias de la seccion o si el editor la recarga. */
  if(!document.__gfAddDelegado_bs){
    document.__gfAddDelegado_bs = true;
    document.addEventListener('submit', function(e){
      var form = e.target.closest ? e.target.closest('.gf-bs__add') : null;
      if(!form || !window.gfCart){ return; }
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var prev = btn ? btn.textContent : '';
      if(btn){ btn.disabled = true; btn.textContent = 'Agregando…'; }
      var id = form.querySelector('[name="id"]');
      var qty = form.querySelector('[name="quantity"]');
      window.gfCart.agregar(id ? id.value : 0, qty ? qty.value : 1, 'bs')
        .then(function(){ if(btn){ btn.disabled=false; btn.textContent='✓ Agregado'; setTimeout(function(){ btn.textContent = prev; }, 1800); } })
        .catch(function(){ if(btn){ btn.disabled=false; btn.textContent=prev; } form.submit(); });
    });
  }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["griflor-cart"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(s){
    if(s.__gf){return;} s.__gf = true;
    s.classList.add('gf-js'); // JS active → hide manual "update" button (live updates instead); persists across inner re-renders
    var sid = s.getAttribute('data-section-id');

    function setBubble(count){
      var t = document.getElementById('cart-bubble-text');
      if(t){ t.textContent = count; }
      document.querySelectorAll('.cart-bubble').forEach(function(b){ b.classList.toggle('visually-hidden', count < 1); });
      try{ document.dispatchEvent(new CustomEvent('cart:refresh', {bubbles:true, detail:{itemCount:count}})); }catch(e){}
    }

    function change(line, qty){
      s.classList.add('is-loading');
      fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/change.js' : '/cart/change.js', {
        method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({ line: line, quantity: qty, sections: sid, sections_url: '/cart' })
      }).then(function(r){ return r.json(); }).then(function(cart){
        if(cart && cart.sections && cart.sections[sid]){
          var tmp = document.createElement('div'); tmp.innerHTML = cart.sections[sid];
          var fresh = tmp.querySelector('[data-gf-cart-inner]');
          var cur = s.querySelector('[data-gf-cart-inner]');
          if(fresh && cur){ cur.innerHTML = fresh.innerHTML; }
        }
        if(cart && typeof cart.item_count === 'number'){ setBubble(cart.item_count); }
        s.classList.remove('is-loading');
      }).catch(function(){ s.classList.remove('is-loading'); window.location.reload(); });
    }

    s.addEventListener('click', function(e){
      var item = e.target.closest('[data-gf-item]');
      if(e.target.closest('[data-gf-remove]')){ e.preventDefault(); if(item){ change(parseInt(item.getAttribute('data-line'),10), 0); } return; }
      if(e.target.closest('[data-gf-inc]') || e.target.closest('[data-gf-dec]')){
        e.preventDefault(); if(!item){return;}
        var input = item.querySelector('[data-gf-qty]');
        var q = parseInt(input.value,10)||0;
        q = e.target.closest('[data-gf-inc]') ? q+1 : Math.max(0, q-1);
        change(parseInt(item.getAttribute('data-line'),10), q);
      }
    });
    s.addEventListener('change', function(e){
      if(e.target.matches('[data-gf-qty]')){
        var item = e.target.closest('[data-gf-item]'); if(!item){return;}
        var q = parseInt(e.target.value,10); if(isNaN(q)||q<0){ q = 0; }
        change(parseInt(item.getAttribute('data-line'),10), q);
      }
    });
  }
  function boot(){ document.querySelectorAll('[data-gf-cart]').forEach(init); }
  if(document.readyState !== 'loading'){ boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["griflor-editorial"] && !Shopify.designMode) return;
  try {
    
(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(s){
    if(s.__gf){return;} s.__gf = true;
    var targets = [s].concat(Array.prototype.slice.call(s.querySelectorAll('.gf-ed__row')));
    if(reduce){s.classList.add('is-in');targets.forEach(function(t){t.classList.add('is-in');});return;}
    var io = new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{threshold:.16});
    s.classList.add('is-in');
    s.querySelectorAll('.gf-ed__row').forEach(function(r){io.observe(r);});
    var imgs = s.querySelectorAll('.gf-ed__img');
    var ticking=false;
    function up(){ticking=false;if(window.innerWidth<750){return;}var vh=window.innerHeight||1;imgs.forEach(function(img){var r=img.getBoundingClientRect();if(r.bottom<0||r.top>vh){return;}var p=(r.top+r.height/2-vh/2)/vh;img.style.transform='translate3d(0,'+(p*-5).toFixed(2)+'%,0)';});}
    function on(){if(!ticking){ticking=true;requestAnimationFrame(up);}}
    window.addEventListener('scroll',on,{passive:true});window.addEventListener('resize',on,{passive:true});up();
  }
  function boot(){document.querySelectorAll('.gf-ed').forEach(init);}
  if(document.readyState !== 'loading'){boot();}else{document.addEventListener('DOMContentLoaded', boot);}
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["griflor-feature"] && !Shopify.designMode) return;
  try {
    
(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(s){
    if(s.__gf){return;} s.__gf = true;
    var io = new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{threshold:.18});
    io.observe(s);
    if(reduce){return;}
    var img = s.querySelector('.gf-ft__img');
    var ticking = false;
    function up(){ticking=false;var r=s.getBoundingClientRect();var vh=window.innerHeight||1;if(r.bottom<0||r.top>vh){return;}var p=(r.top + r.height/2 - vh/2)/vh;var pv=window.innerWidth<750?0:p*-7;if(img){img.style.transform='translate3d(0,'+pv.toFixed(2)+'%,0)';}}
    function on(){if(!ticking){ticking=true;requestAnimationFrame(up);}}
    window.addEventListener('scroll',on,{passive:true});window.addEventListener('resize',on,{passive:true});up();
  }
  function boot(){var l=document.querySelectorAll('.gf-ft');for(var i=0;i<l.length;i++){init(l[i]);}}
  if(document.readyState !== 'loading'){boot();}else{document.addEventListener('DOMContentLoaded', boot);}
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["griflor-gallery"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(s){
    if(s.__gf){return;} s.__gf=true;
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{threshold:.12});
    io.observe(s);
  }
  function boot(){document.querySelectorAll('.gf-gl').forEach(init);}
  if(document.readyState!=='loading'){boot();}else{document.addEventListener('DOMContentLoaded',boot);}
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["griflor-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(hero){
    if(hero.__gf){return;} hero.__gf = true;
    requestAnimationFrame(function(){requestAnimationFrame(function(){hero.classList.add('is-in');});});
    if(reduce){return;}
    // si hay video no le aplicamos parallax: obligaria a sobre-escalarlo y perder nitidez
    var video = hero.querySelector('.gf-hero__video');
    var img = video ? null : hero.querySelector('.gf-hero__img');
    var content = hero.querySelector('.gf-hero__slides') || hero.querySelector('.gf-hero__content');
    var ticking = false;
    function update(){
      ticking = false;
      var r = hero.getBoundingClientRect();
      var vh = window.innerHeight || 1;
      if(r.bottom < -40 || r.top > vh){return;}
      var passed = Math.max(0, -r.top);
      if(img){var ty = window.innerWidth < 750 ? 0 : Math.max(-9, Math.min(9, (-r.top / vh) * 9));img.style.transform = 'translate3d(0,' + ty.toFixed(2) + '%,0) scale(1.1)';}
      if(content){var f = Math.max(0, 1 - passed / (vh * 0.72));content.style.opacity = f.toFixed(3);content.style.transform = 'translateY(' + (passed * 0.05).toFixed(1) + 'px)';}
    }
    function onScroll(){if(!ticking){ticking = true;requestAnimationFrame(update);}}

    // carrusel de placas: marca -> oferta -> marca ...
    var slides = hero.querySelectorAll('[data-gf-slide]');
    var dots = hero.querySelectorAll('[data-gf-dot]');
    if(slides.length > 1){
      var actual = 0;
      var ms = parseInt(hero.getAttribute('data-gf-slide-ms'), 10) || 5000;
      var timer = null;
      function mostrar(i){
        slides[actual].classList.remove('is-active');
        if(dots[actual]){dots[actual].classList.remove('is-active');}
        actual = (i + slides.length) % slides.length;
        slides[actual].classList.add('is-active');
        if(dots[actual]){dots[actual].classList.add('is-active');}
      }
      function arrancar(){ if(timer){clearInterval(timer);} timer = setInterval(function(){mostrar(actual + 1);}, ms); }
      for(var d = 0; d < dots.length; d++){
        (function(idx){
          dots[idx].addEventListener('click', function(){ mostrar(idx); arrancar(); });
        })(d);
      }
      // no rotar si el visitante pidio menos movimiento, ni con la pestana oculta
      if(!reduce){
        arrancar();
        document.addEventListener('visibilitychange', function(){
          if(document.hidden){ clearInterval(timer); } else { arrancar(); }
        });
      }
    }
    window.addEventListener('scroll', onScroll, {passive:true});
    window.addEventListener('resize', onScroll, {passive:true});
    update();
  }
  function boot(){var list = document.querySelectorAll('[data-gf-hero]');for(var i=0;i<list.length;i++){init(list[i]);}}
  if(document.readyState !== 'loading'){boot();}else{document.addEventListener('DOMContentLoaded', boot);}
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["griflor-newsletter"] && !Shopify.designMode) return;
  try {
    
(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(s){
    if(s.__gf){return;} s.__gf = true;
    if(reduce){s.classList.add('is-in');return;}
    var io = new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{threshold:.2});
    io.observe(s);
  }
  function boot(){var l=document.querySelectorAll('.gf-nl');for(var i=0;i<l.length;i++){init(l[i]);}}
  if(document.readyState !== 'loading'){boot();}else{document.addEventListener('DOMContentLoaded', boot);}
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["griflor-product-main"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.__gf){return;} root.__gf = true;
    var main = root.querySelector('[data-gf-main]');
    root.querySelectorAll('[data-gf-thumb]').forEach(function(t){
      t.addEventListener('click', function(){
        if(main){
          main.src = t.getAttribute('data-gf-thumb');
          var z = t.getAttribute('data-gf-thumb-zoom');
          if(z){ main.setAttribute('data-gf-zoom', z); }
        }
        root.querySelectorAll('[data-gf-thumb]').forEach(function(x){x.classList.remove('is-active');});
        t.classList.add('is-active');
      });
    });

    /* Zoom de la foto. La capa se abre al tocar la imagen grande; adentro un
       segundo toque acerca a 2.2x tomando como centro el punto tocado, asi se
       mira justo donde el visitante apunto y no siempre el medio. */
    var capaZoom = root.querySelector('[data-gf-zoom-layer]');
    var imgZoom = root.querySelector('[data-gf-zoom-img]');
    var ayudaZoom = root.querySelector('[data-gf-zoom-ayuda]');
    if(main && capaZoom && imgZoom){
      var cerrarZoom = function(){
        capaZoom.classList.remove('is-open');
        imgZoom.classList.remove('is-cerca');
        imgZoom.style.transformOrigin = 'center center';
        document.body.style.overflow = '';
        setTimeout(function(){ capaZoom.hidden = true; }, 280);
        document.removeEventListener('keydown', porTecla);
      };
      var porTecla = function(e){ if(e.key === 'Escape'){ cerrarZoom(); } };
      var abrirZoom = function(){
        imgZoom.src = main.getAttribute('data-gf-zoom') || main.src;
        imgZoom.alt = main.alt || '';
        capaZoom.hidden = false;
        /* el body queda quieto detras mientras la capa esta abierta */
        document.body.style.overflow = 'hidden';
        if(ayudaZoom){ ayudaZoom.classList.remove('is-oculta'); }
        requestAnimationFrame(function(){ capaZoom.classList.add('is-open'); });
        document.addEventListener('keydown', porTecla);
      };

      main.addEventListener('click', abrirZoom);
      main.style.cursor = 'zoom-in';

      imgZoom.addEventListener('click', function(e){
        e.stopPropagation();
        if(imgZoom.classList.contains('is-cerca')){
          imgZoom.classList.remove('is-cerca');
          imgZoom.style.transformOrigin = 'center center';
        } else {
          var b = imgZoom.getBoundingClientRect();
          var px = ((e.clientX - b.left) / b.width) * 100;
          var py = ((e.clientY - b.top) / b.height) * 100;
          imgZoom.style.transformOrigin = px + '% ' + py + '%';
          imgZoom.classList.add('is-cerca');
        }
        if(ayudaZoom){ ayudaZoom.classList.add('is-oculta'); }
      });
      /* con el zoom puesto, el cursor arrastra el encuadre */
      imgZoom.addEventListener('mousemove', function(e){
        if(!imgZoom.classList.contains('is-cerca')){ return; }
        var b = imgZoom.getBoundingClientRect();
        imgZoom.style.transformOrigin =
          (((e.clientX - b.left) / b.width) * 100) + '% ' +
          (((e.clientY - b.top) / b.height) * 100) + '%';
      });

      capaZoom.addEventListener('click', cerrarZoom);
      var btnCerrar = root.querySelector('[data-gf-zoom-close]');
      if(btnCerrar){ btnCerrar.addEventListener('click', function(e){ e.stopPropagation(); cerrarZoom(); }); }
    }

    var data = root.querySelector('[data-gf-variants]');
    var variants = []; try{ variants = JSON.parse(data.textContent); }catch(e){}
    var idInput = root.querySelector('[data-gf-id]');
    var nowEl = root.querySelector('[data-gf-now]');
    var wasEl = root.querySelector('[data-gf-was]');
    var msiEl = root.querySelector('[data-gf-msi]');
    var cardEl = root.querySelector('[data-gf-card]');
    var atc = root.querySelector('[data-gf-atc]');
    var msi = parseInt(root.getAttribute('data-msi')) || 3;

    function money(cents){
      try{ return new Intl.NumberFormat('es-MX',{style:'currency',currency:'MXN'}).format(cents/100); }
      catch(e){ return '$'+(cents/100).toFixed(2); }
    }
    function currentOptions(){
      var opts = [];
      root.querySelectorAll('[data-gf-opt]').forEach(function(o){
        var sel = o.querySelector('input:checked');
        if(sel){opts.push(sel.value);}
      });
      return opts;
    }
    function update(){
      var opts = currentOptions();
      var match = variants[0];
      if(opts.length){
        match = variants.find(function(vr){ return JSON.stringify(vr.options) === JSON.stringify(opts); }) || match;
      }
      if(!match){return;}
      if(idInput){idInput.value = match.id;}
      var tdu = parseInt(root.getAttribute('data-tdisc')) || 0;
      if(nowEl){
        var nuevoTr = Math.round(match.price * (100 - tdu) / 100);
        nowEl.setAttribute('data-gf-cents', nuevoTr);
        /* al cambiar de variante vuelve a contar: el numero nuevo se nota */
        if(typeof contarPrecio === 'function'){ contarPrecio(nuevoTr); }
        else { nowEl.textContent = money(nuevoTr); }
      }
      if(cardEl){cardEl.textContent = money(match.price);}
      if(wasEl){ if(match.compare_at_price && match.compare_at_price > match.price){wasEl.textContent = money(match.compare_at_price); wasEl.hidden=false;} else {wasEl.hidden=true;} }
      if(msiEl){msiEl.innerHTML = 'o '+msi+'x <strong>'+money(Math.round(match.price/msi))+'</strong> sin intereses';}
      if(atc){ if(match.available){atc.disabled=false; var sp=atc.querySelector('span'); if(sp){sp.textContent = atc.getAttribute('data-add')||'Agregar al carrito';}} else {atc.disabled=true; var s2=atc.querySelector('span'); if(s2){s2.textContent='Agotado';}} atc.classList.remove('is-added'); }
      if(typeof pintarPacks === 'function'){ pintarPacks(match); }
      document.dispatchEvent(new CustomEvent('gf:variant',{detail:{price: nowEl?nowEl.textContent:'', available: match.available}}));
    }
    root.querySelectorAll('[data-gf-swatch]').forEach(function(sw){
      sw.addEventListener('change', function(){
        var pos = sw.getAttribute('data-gf-swatch');
        var grp = sw.closest('[data-gf-opt]');
        grp.querySelectorAll('.gf-pm__swatch').forEach(function(l){l.classList.remove('is-active');});
        sw.closest('.gf-pm__swatch').classList.add('is-active');
        var lbl = grp.querySelector('[data-gf-opt-val]'); if(lbl){lbl.textContent = sw.value;}
        update();
      });
    });

    var qty = root.querySelector('[data-gf-qty]');
    root.querySelector('[data-gf-qminus]') && root.querySelector('[data-gf-qminus]').addEventListener('click',function(){ qty.value = Math.max(1,(parseInt(qty.value)||1)-1); });
    root.querySelector('[data-gf-qplus]') && root.querySelector('[data-gf-qplus]').addEventListener('click',function(){ qty.value = (parseInt(qty.value)||1)+1; });

    // packs: precios por N y resumen del elegido
    var packs = root.querySelectorAll('[data-gf-pack]');
    var resN = root.querySelector('[data-gf-res-n]');
    var resWas = root.querySelector('[data-gf-res-was]');
    var resTotal = root.querySelector('[data-gf-res-total]');
    var resSave = root.querySelector('[data-gf-res-save]');
    var resEnvio = root.querySelector('[data-gf-res-envio]');
    var resMacetas = root.querySelector('[data-gf-res-macetas]');
    var resMacetaTxt = root.querySelector('[data-gf-res-maceta-txt]');
    var resMacetaLbl = root.querySelector('[data-gf-res-maceta-lbl]');
    var resDesc = root.querySelector('[data-gf-res-desc]');
    var resDescN = root.querySelector('[data-gf-res-desc-n]');
    var resDescPct = root.querySelector('[data-gf-res-desc-pct]');
    var resTotalTr = root.querySelector('[data-gf-res-total-tr]');
    var resMsi = root.querySelector('[data-gf-res-msi]');
    var envioDesde = parseInt(root.getAttribute('data-envio-desde')) || 0;

    function packElegido(){
      var sel = root.querySelector('[data-gf-pack].is-active');
      return sel || packs[0];
    }
    function pintarResumen(){
      var el = packElegido();
      if(!el || !resTotal){return;}
      var n = parseInt(el.getAttribute('data-gf-pack')) || 1;
      var total = parseInt(el.getAttribute('data-gf-total')) || 0;
      var was = parseInt(el.getAttribute('data-gf-was')) || 0;
      var ahorro = was - total;
      if(resN){resN.textContent = n;}
      if(resMacetas){resMacetas.textContent = n;}
      if(resMacetaTxt){resMacetaTxt.textContent = n === 1 ? 'maceta' : 'macetas';}
      if(resMacetaLbl){resMacetaLbl.textContent = n === 1 ? 'INCLUIDA' : 'INCLUIDAS';}
      var disc = parseInt(el.querySelector('[data-gf-disc]').getAttribute('data-gf-disc')) || 0;
      if(resDesc){
        resDesc.hidden = disc <= 0;
        if(resDescN){resDescN.textContent = n;}
        if(resDescPct){resDescPct.textContent = '−' + disc + '%';}
      }
      if(resWas){resWas.textContent = money(was); resWas.hidden = was <= total;}
      resTotal.textContent = money(total);
      if(resEnvio){resEnvio.hidden = !(envioDesde > 0 && n >= envioDesde);}
      // los dos descuentos se suman sobre el bruto: 10 de pack + 10 de transferencia = 20
      var tdc = parseInt(root.getAttribute('data-tdisc')) || 0;
      var bruto = parseInt(el.getAttribute('data-gf-bruto')) || total;
      var totalTr = Math.round(bruto * (100 - disc - tdc) / 100);
      if(resTotalTr){ resTotalTr.textContent = money(totalTr); }
      // la cuota se calcula sobre el precio con tarjeta, no sobre el de transferencia
      if(resMsi){ resMsi.textContent = msi + 'x ' + money(Math.round(total / msi)); }
      if(resSave){
        var ahorroTr = was - totalTr;
        if(ahorroTr > 0){
          var pct = Math.round(ahorroTr * 100 / was);
          resSave.innerHTML = 'Ahorras ' + money(ahorroTr) + ' <i>(' + pct + '%)</i>';
          resSave.hidden = false;
        } else { resSave.hidden = true; }
      }
    }
    // recalcula los 3 packs cuando cambia la variante
    function pintarPacks(match){
      packs.forEach(function(el){
        var n = parseInt(el.getAttribute('data-gf-pack')) || 1;
        var disc = parseInt(el.querySelector('[data-gf-disc]').getAttribute('data-gf-disc')) || 0;
        var baseWas = (match.compare_at_price && match.compare_at_price > match.price) ? match.compare_at_price : match.price;
        var total = Math.round(match.price * n * (100 - disc) / 100);
        var was = baseWas * n;
        el.setAttribute('data-gf-bruto', match.price * n);
        el.setAttribute('data-gf-total', total);
        el.setAttribute('data-gf-was', was);
        el.setAttribute('data-gf-unit', Math.round(total / n));
        el.setAttribute('data-gf-ahorro', was - total);
        var tdc2 = parseInt(root.getAttribute('data-tdisc')) || 0;
        var totalTr2 = Math.round(match.price * n * (100 - disc - tdc2) / 100);
        var tot = el.querySelector('[data-gf-total-txt]'); if(tot){tot.textContent = money(totalTr2);}
        var uni = el.querySelector('[data-gf-unit-txt]'); if(uni){uni.textContent = money(Math.round(totalTr2 / n));}
        var wasEl2 = el.querySelector('[data-gf-was-txt]');
        if(wasEl2){ wasEl2.textContent = money(was); wasEl2.hidden = was <= total; }
      });
      pintarResumen();
    }

    /* El pack inicial lo manda el tema, no el navegador. Hace falta forzarlo
       porque al refrescar se restaura el estado de los radios y del input de
       cantidad, y al volver con "Atras" la pagina sale del bfcache tal como
       quedo, sin que el script vuelva a correr. */
    function forzarPackInicial(){
      var bundle = root.querySelector('[data-gf-bundle]');
      if(!bundle){ return; }
      var ini = parseInt(bundle.getAttribute('data-gf-pack-ini'));
      if(!ini){ return; }
      var radio = root.querySelector('input[name="gf-tier"][value="' + ini + '"]');
      if(!radio){ return; }
      radio.checked = true;
      root.querySelectorAll('.gf-pm__tier').forEach(function(l){ l.classList.remove('is-active'); });
      var lab = radio.closest('.gf-pm__tier');
      if(lab){ lab.classList.add('is-active'); }
      if(qty){ qty.value = ini; }
    }
    forzarPackInicial();
    /* pageshow cubre el regreso desde el bfcache: es el unico evento que
       dispara el navegador en ese caso. */
    window.addEventListener('pageshow', function(e){
      if(!e.persisted){ return; }
      forzarPackInicial();
      pintarResumen();
    });

    root.querySelectorAll('[data-gf-tier]').forEach(function(tier){
      tier.addEventListener('change', function(){
        root.querySelectorAll('.gf-pm__tier').forEach(function(l){l.classList.remove('is-active');});
        tier.closest('.gf-pm__tier').classList.add('is-active');
        if(qty){qty.value = tier.getAttribute('data-gf-tier');}
        pintarResumen();
      });
    });
    pintarResumen();

    /* El precio cuenta de 0 hasta su valor la primera vez que entra en pantalla,
       y cada vez que cambia la variante. Se anima el NUMERO, no un texto: se
       reformatea con money() en cada frame para que conserve los separadores y
       el simbolo de moneda. */
    var animPrecio = null;
    function contarPrecio(hasta){
      if(!nowEl){ return; }
      if(animPrecio){ cancelAnimationFrame(animPrecio); animPrecio = null; }
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if(reduce || !hasta){ nowEl.textContent = money(hasta || 0); return; }
      var dur = 900, t0 = null;
      nowEl.classList.add('is-contando');
      function paso(ts){
        if(t0 === null){ t0 = ts; }
        var k = Math.min(1, (ts - t0) / dur);
        /* easeOutExpo: arranca rapido y frena al final, asi el numero final
           queda quieto un instante antes de terminar */
        var e = k === 1 ? 1 : 1 - Math.pow(2, -10 * k);
        nowEl.textContent = money(Math.round(hasta * e));
        if(k < 1){ animPrecio = requestAnimationFrame(paso); }
        else {
          animPrecio = null;
          nowEl.textContent = money(hasta);
          nowEl.classList.remove('is-contando');
          nowEl.classList.add('is-listo');
          setTimeout(function(){ nowEl.classList.remove('is-listo'); }, 700);
        }
      }
      animPrecio = requestAnimationFrame(paso);
    }
    if(nowEl){
      var destino = parseInt(nowEl.getAttribute('data-gf-cents')) || 0;
      if('IntersectionObserver' in window){
        var ioPrecio = new IntersectionObserver(function(es){
          es.forEach(function(e){
            if(!e.isIntersecting){ return; }
            ioPrecio.unobserve(e.target);
            contarPrecio(parseInt(nowEl.getAttribute('data-gf-cents')) || destino);
          });
        }, { threshold: 0.6 });
        ioPrecio.observe(nowEl);
      } else {
        contarPrecio(destino);
      }
    }

    var form = root.querySelector('#gf-product-form');
    if(form && atc){
      form.addEventListener('submit', function(e){
        e.preventDefault();
        atc.disabled = true; var sp = atc.querySelector('span'); var prev = sp?sp.textContent:'';
        if(sp){sp.textContent = 'Agregando…';}
        window.gfCart.agregar(idInput.value, qty.value, 'gf-pm')
          .then(function(){
            /* el carrito lateral ya se abrio: el boton solo confirma y vuelve */
            atc.disabled=false; atc.classList.add('is-added'); if(sp){sp.textContent='✓ Agregado';}
            setTimeout(function(){ atc.classList.remove('is-added'); if(sp){sp.textContent=prev;} }, 1800);
          })
          .catch(function(){ form.submit(); });
      });
    }

    var buy = root.querySelector('[data-gf-buy]');
    if(buy){
      buy.addEventListener('click', function(){
        buy.disabled = true;
        var sp = buy.querySelector('span'); var prev = sp ? sp.textContent : '';
        if(sp){ sp.textContent = 'Un momento…'; }
        fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({ items:[{ id: parseInt(idInput.value), quantity: parseInt(qty.value)||1 }] }) })
          .then(function(r){ if(!r.ok){throw new Error('add');} return r.json(); })
          .then(function(){ window.location.href = '/checkout'; })
          .catch(function(){ buy.disabled=false; if(sp){sp.textContent=prev;} if(form){form.submit();} });
      });
    }

    update();
  }
  function boot(){ document.querySelectorAll('.gf-pm').forEach(init); }
  if(document.readyState !== 'loading'){boot();}else{document.addEventListener('DOMContentLoaded', boot);}
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["griflor-related"] && !Shopify.designMode) return;
  try {
    
(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SKEL = '<div class="gf-rel__skeleton"><span></span><span></span><span></span><span></span></div>';

  function carousel(s){
    var track = s.querySelector('[data-gf-track]');
    var prev = s.querySelector('[data-gf-prev]'), next = s.querySelector('[data-gf-next]');
    if(!track){ if(prev){prev.style.display='none';} if(next){next.style.display='none';} return; }
    function step(){var c = track.querySelector('.gf-rel__card');return c ? c.getBoundingClientRect().width + 20 : 300;}
    if(prev){prev.onclick = function(){track.scrollBy({left:-step()*1.25, behavior:'smooth'});};}
    if(next){next.onclick = function(){track.scrollBy({left:step()*1.25, behavior:'smooth'});};}
  }

  function reveal(s){
    if(reduce){s.classList.add('is-in');return;}
    var io = new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{threshold:.12});
    io.observe(s);
  }

  function finalize(s){
    if(s.querySelector('.gf-rel__card')){ carousel(s); reveal(s); }
    else { s.classList.add('gf-rel--empty'); }
  }

  function init(s){
    if(s.__gf){return;} s.__gf = true;
    var body = s.querySelector('[data-gf-rel-body]');
    var url = s.getAttribute('data-fetch-url');
    var done = body && body.getAttribute('data-performed') === 'true';
    if(done || !url || !body){ finalize(s); return; }
    var previo = body.innerHTML;
    body.innerHTML = SKEL;
    fetch(url).then(function(r){return r.text();}).then(function(html){
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var fresh = tmp.querySelector('[data-gf-rel-body]');
      // solo se reemplaza si la API trajo tarjetas: si no, se deja el respaldo
      if(fresh && fresh.querySelector('.gf-rel__card')){ body.innerHTML = fresh.innerHTML; }
      else { body.innerHTML = previo; }
      finalize(s);
    }).catch(function(){ body.innerHTML = previo; finalize(s); });
  }

  function boot(){var l = document.querySelectorAll('[data-gf-rel]');for(var i=0;i<l.length;i++){init(l[i]);}}
  if(document.readyState !== 'loading'){boot();}else{document.addEventListener('DOMContentLoaded', boot);}

  /* Agregar sin salir de la pagina: abre el carrito lateral del tema.
     Delegado en document y con guarda, asi no se duplica si hay varias
     instancias de la seccion o si el editor la recarga. */
  if(!document.__gfAddDelegado_rel){
    document.__gfAddDelegado_rel = true;
    document.addEventListener('submit', function(e){
      var form = e.target.closest ? e.target.closest('.gf-rel__add') : null;
      if(!form || !window.gfCart){ return; }
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var prev = btn ? btn.textContent : '';
      if(btn){ btn.disabled = true; btn.textContent = 'Agregando…'; }
      var id = form.querySelector('[name="id"]');
      var qty = form.querySelector('[name="quantity"]');
      window.gfCart.agregar(id ? id.value : 0, qty ? qty.value : 1, 'rel')
        .then(function(){ if(btn){ btn.disabled=false; btn.textContent='✓ Agregado'; setTimeout(function(){ btn.textContent = prev; }, 1800); } })
        .catch(function(){ if(btn){ btn.disabled=false; btn.textContent=prev; } form.submit(); });
    });
  }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["griflor-reviews"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(s){
    if(s.__gf){return;} s.__gf=true;
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{threshold:.12});
    io.observe(s);
  }
  function boot(){document.querySelectorAll('.gf-rv').forEach(init);}
  if(document.readyState!=='loading'){boot();}else{document.addEventListener('DOMContentLoaded',boot);}
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["griflor-shopthelook"] && !Shopify.designMode) return;
  try {
    
(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(s){
    if(s.__gf){return;} s.__gf = true;
    if(reduce){s.classList.add('is-in');return;}
    var io = new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{threshold:.14});
    io.observe(s);
  }
  function boot(){var l=document.querySelectorAll('.gf-stl');for(var i=0;i<l.length;i++){init(l[i]);}}
  if(document.readyState !== 'loading'){boot();}else{document.addEventListener('DOMContentLoaded', boot);}
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["griflor-specs"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(s){
    if(s.__gf){return;} s.__gf=true;
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{threshold:.15});
    io.observe(s);
  }
  function boot(){document.querySelectorAll('.gf-sp').forEach(init);}
  if(document.readyState!=='loading'){boot();}else{document.addEventListener('DOMContentLoaded',boot);}
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["griflor-sticky-atc"] && !Shopify.designMode) return;
  try {
    
(function(){
  function boot(){
    var bar = document.querySelector('[data-gf-sticky]');
    var buybox = document.querySelector('.gf-pm');
    if(!bar || !buybox || bar.__gf){return;}
    bar.__gf = true;
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', past);
      });
    }, { threshold: 0 });
    io.observe(buybox);

    var addBtn = bar.querySelector('[data-gf-sa-add]');
    if(addBtn){
      addBtn.addEventListener('click', function(){
        var form = document.getElementById('gf-product-form');
        if(form && form.requestSubmit){ form.requestSubmit(); }
        else if(form){ form.querySelector('[type=submit]') && form.querySelector('[type=submit]').click(); }
        addBtn.classList.add('is-added'); addBtn.textContent = '✓ Agregado';
        setTimeout(function(){ addBtn.classList.remove('is-added'); addBtn.textContent = addBtn.getAttribute('data-label') || 'Agregar'; }, 2200);
      });
      addBtn.setAttribute('data-label', addBtn.textContent);
    }

    document.addEventListener('gf:variant', function(ev){
      var pe = bar.querySelector('[data-gf-sa-price]');
      if(pe && ev.detail && ev.detail.price){ pe.textContent = ev.detail.price; }
    });
  }
  if(document.readyState !== 'loading'){boot();}else{document.addEventListener('DOMContentLoaded', boot);}
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["griflor-story"] && !Shopify.designMode) return;
  try {
    
(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function fmt(n){try{return n.toLocaleString('es-MX');}catch(e){return String(n);}}
  function count(el, orden){
    var target = parseFloat(el.getAttribute('data-gf-num')) || 0;
    if(reduce || target === 0){el.textContent = fmt(target);return;}
    var dur = 2200, retraso = (orden || 0) * 160, start = null;
    function tick(ts){
      if(!start){start = ts;}
      var transcurrido = ts - start - retraso;
      if(transcurrido < 0){requestAnimationFrame(tick);return;}
      var p = Math.min(1, transcurrido/dur);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(Math.round(target * e));
      if(p < 1){requestAnimationFrame(tick);}else{el.textContent = fmt(target);}
    }
    requestAnimationFrame(tick);
  }
  function init(s){
    if(s.__gf){return;} s.__gf = true;
    var io = new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');var ns=e.target.querySelectorAll('[data-gf-num]');for(var i=0;i<ns.length;i++){count(ns[i], i);}io.unobserve(e.target);}});},{threshold:.22});
    io.observe(s);
  }
  function boot(){var l=document.querySelectorAll('.gf-st');for(var i=0;i<l.length;i++){init(l[i]);}}
  if(document.readyState !== 'loading'){boot();}else{document.addEventListener('DOMContentLoaded', boot);}
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["griflor-testimonials"] && !Shopify.designMode) return;
  try {
    
(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(s){
    if(s.__gf){return;} s.__gf = true;
    if(reduce){s.classList.add('is-in');return;}
    var io = new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{threshold:.16});
    io.observe(s);
  }
  function boot(){var l = document.querySelectorAll('.gf-tm');for(var i=0;i<l.length;i++){init(l[i]);}}
  if(document.readyState !== 'loading'){boot();}else{document.addEventListener('DOMContentLoaded', boot);}
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["griflor-trustbar"] && !Shopify.designMode) return;
  try {
    
(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function boot(){
    var els = document.querySelectorAll('.gf-trust');
    for(var i=0;i<els.length;i++){
      (function(el){
        if(el.__gf){return;} el.__gf = true;
        if(reduce){el.classList.add('is-in');return;}
        var io = new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{threshold:.25});
        io.observe(el);
      })(els[i]);
    }
  }
  if(document.readyState !== 'loading'){boot();}else{document.addEventListener('DOMContentLoaded', boot);}
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
